import React, { useEffect, useState } from "react";
import { Main, Content } from "../../../components/Layout";
import api from "../../../services/api";
import { ChartsBar } from "../../../components/Charts";
import { Col, Row, Table } from "react-bootstrap";
import Slct from "../../../components/Slct";
import tableStyle from "../../../components/Table/Table.module.css";
import styleButton from "../../../components/Button/Button.module.css";
import getCommercial from "../../../util/getCommercial";
import useWrapper from "../../../hooks/useWrapper";

export default function ReportsOperationalSuppliers() {
  const { setbreadcrumb, config } = useWrapper();

  const [providers, setproviders] = useState([]);
  const [total, settotal] = useState(0);
  const [, setCommercial] = useState([]);
  useEffect(() => {
    (async function () {
      const _commercial = await getCommercial(null, null, `?is_class=1`);
      setCommercial(_commercial);
      console.log("_commercial", _commercial);

      const _providers = await api.get("providers?paginate=false", config);
      setproviders(
        _providers.data.map(e => ({
          value: e.id,
          label: e.name,
        })),
      );
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `config` is recreated on every WrapperProvider render; this should only run once on mount.
  }, []);

  const [filter, setFilter] = useState({
    id: "",
    type: "events",
  });

  const [reports, setReports] = useState({
    data: [],
    title: "",
    type: "",
    table: [],
  });

  function convertToCSV(objArray) {
    var array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
    var str = "";

    for (var i = 0; i < array.length; i++) {
      var line = "";
      for (var index in array[i]) {
        if (line !== "") line += ",";
        line += array[i][index];
      }
      str += line + "\r\n";
    }
    return str;
  }

  useEffect(() => {
    if (filter.provider) {
      (async function () {
        const _provider_response = await api.get(`/provider/report?id=${filter.provider}`, config);

        let responseVar = [..._provider_response.data];

        let tableVar = [];
        let _total = 0;
        let _data = [];

        responseVar.forEach((e, index) => {
          e.budgetResources.forEach((r, i) => {
            if (r.budgets.main === 1) {
              tableVar.push({
                Turma: r.budgets.commercials
                  ? `${r.budgets.commercials.course ? r.budgets.commercials.course.title : ""} ${
                      r.budgets.commercials.year
                    }.${r.budgets.commercials.period} (${
                      r.budgets.commercials.institution ? r.budgets.commercials.institution.title : ""
                    })`
                  : "-",
                Evento: r.events.name,
                Recurso: r.resources.name,
                Quantidade: r.qtd || 0,
                "Valor unitario": r.single_value || 0,
                "Valor Total": parseInt(r.qtd || 0) * parseFloat(r.single_value || 0),
                Descricao: r.description,
                type: r.id,
              });
              _total = _total + parseInt(r.qtd || 0) * parseFloat(r.single_value || 0);
              _data[r.resources.id] = {
                label: r.resources.name,
                value: _data[r.resources.id]?.value || 0 + parseInt(r.qtd || 0) * parseFloat(r.single_value || 0),
              };
            }
          });
        });
        settotal(_total);
        setReports({
          data: _data,
          title: "Recursos do fornecedores",
          type: "recursos",
          table: tableVar,
        });
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `config` is recreated on every WrapperProvider render; this should only re-run when `filter` changes.
  }, [filter]);

  useEffect(() => {
    setbreadcrumb([{ label: "Relatórios" }]);
  }, [setbreadcrumb]);

  return (
    <Main>
      <Content>
        <Row>
          <Col>
            <div className="d-flex justify-content-between">
              <h2 className="page-title">Relatórios do Operacional</h2>
              <div className="d-flex ml-4">
                <button
                  type="button"
                  className={`${styleButton.button_primary} ml-3`}
                  onClick={() => {
                    let _teste = [[reports.title], ""];
                    reports.data.forEach(e => {
                      _teste.push([e.label, e.value]);
                    });
                    _teste.push("");

                    reports.table.forEach(e => {
                      _teste.push([e.label, e.type]);
                    });

                    let _teste_string = JSON.stringify(_teste);
                    let _teste_csv = convertToCSV(_teste_string);
                    let _teste_blob = new Blob([_teste_csv], { type: "text/csv;charset=utf-8;" });

                    let link = document.createElement("a");
                    let url = URL.createObjectURL(_teste_blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", "teste.csv");
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                >
                  <span>Gerar CSV</span>
                </button>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-2" style={{ zIndex: 10, position: "relative" }}>
          <Col sm={3}>
            <span className="lince-input_label">Fornecedores</span>
            <Slct
              className="w-100"
              placeholder="..."
              value={filter.provider}
              options={providers}
              onChange={e => {
                setFilter({
                  ...filter,
                  provider: e.value,
                });
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            {reports.table.length ? (
              <ChartsBar reports={reports.data} title={reports.title} type={reports.type} />
            ) : (
              <></>
            )}
            {filter.provider ? (
              <>
                {/* <h4 className={`mini-title mt-4`}>Recursos</h4> */}
                {reports.table.length ? (
                  <>
                    <Table className={`${tableStyle.table}  mt-2`}>
                      <thead>
                        <tr>
                          <th>Turma</th>
                          <th>Evento</th>
                          <th>Recurso</th>
                          <th>Quantidade</th>
                          <th>Valor unitario</th>
                          <th>Valor Total</th>
                          <th>Descição</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reports.table &&
                          reports.table.map((e, i) => (
                            <>
                              <tr key={i}>
                                <td>{e["Turma"]}</td>
                                <td>{e["Recurso"]}</td>
                                <td>{e["Turma"]}</td>
                                <td>{e["Quantidade"]}</td>
                                <td>{e["Valor unitario"].toFixed(2)}</td>
                                <td>{e["Valor Total"].toFixed(2)}</td>
                                <td>{e["Descricao"] || "Sem observações"}</td>
                              </tr>
                            </>
                          ))}
                      </tbody>
                    </Table>
                    <Row>
                      <Col sm={{ span: 4, offset: 8 }}>
                        <div className="row-calc-bg">
                          <span>Total</span> <span>R$ {total?.toFixed(2)}</span>
                        </div>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <p>Esse fornecedor não possui nenhum recurso associado.</p>
                )}
              </>
            ) : (
              <p>Selecione um fornecedor.</p>
            )}
          </Col>
        </Row>
      </Content>
    </Main>
  );
}
